import React, { useEffect, useState } from "react";
import CryptoChart from "../Components/CryptoChart";

const Crypto = () => {
  const [crypto, setCrypto] = useState(null);

  useEffect(() => {
    fetch(
      "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=1&page=1"
    )
      .then((res) => res.json())
      .then((data) => setCrypto(data[0])) // Get Bitcoin data
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <div className="container mx-auto p-6">
      {crypto ? <CryptoChart data={crypto} /> : <p>Loading...</p>}
    </div>
  );
};

export default Crypto;
